module.exports = __webpack_public_path__ + "static/media/icon_user.e0f18e26.svg";